import React, { useState, useEffect } from 'react';
import ComanServices from '../../services/ComanServices';
import { Link } from 'react-router-dom';

function TraindingStock() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await ComanServices.stock();
        console.log(response); // Make sure to structure your response properly
        setBlogs(response?.data || []);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching blogs:', error);
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <section className="blog-b-section py-70">
      <div className="container">
        <div className="tab-content" id="blog-b-tabContent">
          <div className="blog-section-inner">
            <div className="row gy-4">
              {/* Dynamically render blogs */}
              {blogs.map((blog) => (
                <div className="col-md-6 col-lg-4" key={blog.id}>
                  <div className="blog-card">
                    <div className="blog-card-img-box">
                      <img
                        src={process.env.REACT_APP_URL + blog?.images[0] || 'img/default-blog-img.svg'} // Dynamically load the blog image or a default image
                        alt="blog-card-img"
                      />
                    </div>
                    <div className="blog-card-content">
                      <ul className="list-unstyled d-flex justify-content-between align-items-center">
                        <li>
                          <span><img src="img/user-icon.svg" alt="user-icon" /></span>
                          <span>{blog.stock || 'Unknown Author'}</span>
                        </li>
                        <li>
                          <span><img src="img/date-icon.svg" alt="date-icon" /></span>
                          <span>{new Date(blog.createdAt).toLocaleDateString()}</span>
                        </li>
                      </ul>
                      <h5><Link to={`/tainding-stock/${blog?._id}`}>{blog?.title}</Link></h5>
                      <Link to={`/tainding-stock/${blog?._id}`} className="site-btn btn-blue">Read more</Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Pagination could be dynamically added here if needed */}
        <nav aria-label="Page navigation example" style={{ marginTop: '30px' }}>
          <ul className="pagination">
            <li className="page-item active"><a className="page-link" href="#">1</a></li>
            <li className="page-item"><a className="page-link" href="#">2</a></li>
            <li className="page-item"><a className="page-link" href="#">3</a></li>
            <li className="page-item">
              <a className="page-link" href="#"><i className="fa fa-chevron-right" /></a>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
}

export default TraindingStock;
